import { Link } from "react-router-dom";
import Logo from "../common/Logo";
import ThemeToggle from "../common/ThemeToggle";
import "./Header.css";

function Header() {
  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          <Logo />
        </Link>
        <nav className="header-nav">
          <Link to="/capabilities" className="header-nav-item">Capabilities</Link>
          <Link to="/work" className="header-nav-item">Work</Link>
          <Link to="/bliss" className="header-nav-item">Bliss</Link>
          <ThemeToggle />
          <Link to="/contact" className="header-nav-item header-nav-item--cta">Contact</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
